export const NAV = {
  logo: "nav-logo",
  home: "nav-home",
  about: "nav-about",
  products: "nav-products",
  industries: "nav-industries",
  contact: "nav-contact",
  quoteBtn: "nav-quote-btn",
  mobileToggle: "nav-mobile-toggle",
};

export const HERO = {
  title: "hero-title",
  ctaQuote: "hero-cta-quote",
  ctaExplore: "hero-cta-explore",
};

export const HOME_SECTIONS = {
  stats: "home-stats",
  featured: "home-featured",
  whyus: "home-whyus",
  clients: "home-clients",
  testimonials: "home-testimonials",
  inquiryCta: "home-inquiry-cta",
};

export const PRODUCTS = {
  grid: "products-grid",
  searchInput: "products-search",
  categoryFilter: (slug) => `products-cat-${slug}`,
  card: (slug) => `product-card-${slug}`,
  viewBtn: (slug) => `product-view-${slug}`,
  inquireBtn: (slug) => `product-inquire-${slug}`,
};

export const DETAIL = {
  root: "product-detail",
  title: "product-detail-title",
  mainImg: "product-detail-main-img",
  thumb: (i) => `product-detail-thumb-${i}`,
  inquireBtn: "product-detail-inquire-btn",
  tabDetails: "product-detail-tab-details",
  tabSpecs: "product-detail-tab-specs",
  tabApps: "product-detail-tab-apps",
};

export const INQUIRY = {
  dialog: "inquiry-dialog",
  name: "inquiry-name",
  company: "inquiry-company",
  email: "inquiry-email",
  phone: "inquiry-phone",
  location: "inquiry-location",
  product: "inquiry-product",
  quantity: "inquiry-quantity",
  budget: "inquiry-budget",
  delivery: "inquiry-delivery",
  requirements: "inquiry-requirements",
  submit: "inquiry-submit",
  cancel: "inquiry-cancel",
};

export const CONTACT = {
  form: "contact-form",
  submit: "contact-submit",
};

export const FOOTER = { root: "footer-root", ctaBtn: "footer-cta-btn" };
